const serviceFrench = () => ({
  servicesTitle: 'Mes services',
  title: {
    part1: 'PLUS DE 5 ANS D\'',
    part2: 'EXPÉRIENCE EN DÉVELOPPEMENT',
    part3: 'WEBFLOW',
  },
  services: {
    serv1: 'DÉVELOPPEMENT',
    serv2: 'DESIGN',
    serv3: 'SOLUTIONS TECH',
    serv4: 'EXPÉRIENCE UTILISATEUR',
  },
  ilustration: {
    backend: 'Développement backend',
    frontend: 'Développement frontend',
    mobile: 'Développement mobile',
  },
});

export default serviceFrench;
